<div class="titulo">
  <svg>
    <use attr.xlink:href="{{icono}}"></use>
  </svg>
  <h2>{{titulo}}</h2>
</div>
